import { MapPin } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/api";

const LOCATIONS = [
  { name: "Samruddhi Mahamarg", note: "Expressway corridor shaping new growth belts" },
  { name: "Umred Road", note: "Established route with developing surroundings" },
  { name: "Wardha Road", note: "One of Nagpur's primary arterial stretches" },
  { name: "Nagpur", note: "The city anchor for all our listings" },
];

export default function Locations() {
  return (
    <section id="locations" data-testid="locations-section" className="bg-navy py-24 text-white lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <SectionHeading
              dark
              chapter="03"
              eyebrow="Where We Focus"
              title="Strategically Located Around Nagpur"
              description="Location matters when investing in land. We focus on properties with convenient connectivity and potential for future development."
            />
            <ul className="mt-10 space-y-4">
              {LOCATIONS.map((loc, i) => (
                <Reveal key={loc.name} delay={i * 0.08}>
                  <li className="flex items-start gap-4 rounded-sm border border-white/10 bg-white/5 p-5 transition-colors duration-300 hover:border-gold/40">
                    <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" />
                    <div>
                      <p className="font-display text-lg font-semibold">{loc.name}</p>
                      <p className="mt-1 text-sm text-white/60">{loc.note}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <Reveal delay={0.15}>
            <div className="relative overflow-hidden rounded-xl">
              <img
                src={IMAGES.map}
                alt="Highway corridor near Nagpur representing property locations"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
              />
              <div className="absolute inset-0 bg-navy/40" />
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-navy">
                  <MapPin className="h-6 w-6" aria-hidden="true" />
                </span>
                <p className="rounded-sm bg-navy/80 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white backdrop-blur">
                  Interactive map coming soon
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
